import { render, staticRenderFns } from "./OgSavedFilters.vue?vue&type=template&id=9272acd6&"
import script from "./OgSavedFilters.vue?vue&type=script&lang=js&"
export * from "./OgSavedFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports